<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pl-8 tw-pr-12">
    <div
      class=" tw-flex tw-justify-start tw-items-center tw-w-full tw-rounded-l-full tw-rounded-r-full tw-bg-bgDark tw-border-bgDark tw-border-4 tw-border-solid tw-mb-4 tw-p-4 "
    >
      <img :src="getAssetPath('/assets/images/textSize.svg')" alt="Text Size" />
      <input
        type="range"
        class="tw-flex-1 tw-mx-4 tw-cursor-pointer rangeInput"
        min="1"
        max="100"
        v-model="fontSize"
        :style="{ '--scale-progress': `${((fontSize - 1) / (100 - 1)) * 100}%` }"
        @input="(event) => $emit('onFontSizeChange', fontSize)"
      />
      <span
        class="tw-text-white tw-w-[30px] tw-text-right"
        style="font-family: JakartaSans"
        >{{ fontSize }}</span
      >
    </div>

    <div
      class=" tw-flex tw-justify-between tw-items-center tw-w-full tw-rounded-l-full tw-rounded-r-full tw-bg-bgDark tw-border-bgDark tw-border-4 tw-border-solid tw-mb-4 tw-p-4 "
    >
      <img
        :src="boldImage"
        alt="Bold"
        @click="setFontDecoration('bold')"
        class="tw-cursor-pointer"
      />
      <img
        :src="italicImage"
        alt="Italic"
        @click="setFontDecoration('italic')"
        class="tw-cursor-pointer"
      />
      <img
        :src="underlineImage"
        alt="Underline"
        @click="setFontDecoration('underline')"
        class="tw-cursor-pointer"
      />
      <img
        :src="linethroughImage"
        alt="Linethrough"
        @click="setFontDecoration('linethrough')"
        class="tw-cursor-pointer"
      />
    </div>

    <div
      class=" tw-flex tw-justify-between tw-items-center tw-w-full tw-rounded-l-full tw-rounded-r-full tw-bg-bgDark tw-border-bgDark tw-border-4 tw-border-solid tw-mb-4 tw-p-4 "
    >
      <img
        :src="alignLeftImage"
        alt="Align Left"
        @click="setTextAlign('left')"
        class="tw-cursor-pointer"
        :style="{ opacity: textAlign === 'left' ? '100%' : '50%' }"
      />
      <img
        :src="alignCenterImage"
        alt="Align Center"
        @click="setTextAlign('center')"
        class="tw-cursor-pointer"
        :style="{ opacity: textAlign === 'center' ? '100%' : '50%' }"
      />
      <img
        :src="alignRightImage"
        alt="Align Right"
        @click="setTextAlign('right')"
        class="tw-cursor-pointer"
        :style="{ opacity: textAlign === 'right' ? '100%' : '50%' }"
      />
    </div>
  </div>
</template>

<script>
import { getAssetPath } from "@/utils/assetPath";

export default {
  setup() {
    return {
      getAssetPath
    };
  },
  props: {
    selectedElement: {
      required: true,
    },
  },
  computed: {
      alignLeftImage() {
        return this.images[`alignLeft${this.textAlign === "left" ? "Active" : ""}`];
      },
      alignCenterImage() {
        return this.images[`alignCenter${this.textAlign === "center" ? "Active" : ""}`];
      },
      alignRightImage() {
        return this.images[`alignRight${this.textAlign === "right" ? "Active" : ""}`];
      },
      boldImage() {
        return this.images[`bold${this.bold ? "Active" : ""}`];
      },
      italicImage() {
        return this.images[`italic${this.italic ? "Active" : ""}`];
      },
      underlineImage() {
        return this.images[`underline${this.underline ? "Active" : ""}`];
      },
      linethroughImage() {
        return this.images[`linethrough${this.linethrough ? "Active" : ""}`];
      },
  },
  async created() {
    const imageNames = [
      "alignLeft",
      "alignLeftActive",
      "alignCenter",
      "alignCenterActive",
      "alignRight",
      "alignRightActive",
      "bold",
      "boldActive",
      "italic",
      "italicActive",
      "underline",
      "underlineActive",
      "linethrough",
      "linethroughActive",
    ];
    for (const name of imageNames) {
      this.images[name] = this.getAssetPath(`/assets/images/${name}.svg`);
    }
  },
  methods: {
    setTextAlign(align) {
      this.$emit("onAlignChange", align);
      this.setTextStyles();
    },

    setFontDecoration(type) {
      this.$emit("onFontDecoration", type);
      this.setTextStyles();
    },

    setTextStyles() {
      if (!this.selectedElement) return;

      const {
        textAlign,
        fontSize,
        fontWeight,
        fontStyle,
        underline,
        linethrough,
      } = this.selectedElement;

      this.textAlign = textAlign;
      this.fontSize = fontSize;
      this.bold = fontWeight === "bold";
      this.italic = fontStyle === "italic";
      this.underline = underline;
      this.linethrough = linethrough;
    },
  },
  watch: {
    selectedElement() {
      if (!this.selectedElement) return;

      this.setTextStyles();
    },
  },
  mounted() {
    this.setTextStyles();
  },
  data() {
    return {
      textAlign: "left",
      fontSize: 40,
      bold: false,
      italic: false,
      underline: false,
      linethrough: false,
      images: {}
    };
  },
};
</script>

<style>
</style>
